module.exports = __webpack_public_path__ + "assets/img/pandapakita-light.96edd009.png";